import styled from 'styled-components'

export const Content = styled.div`
    width: 100%;
    padding: 0 15px 15px 15px;
`